import { RestCRUDService } from "../../../../service/common/rest/RestCRUDService";

export class RiskManagerReportRootService {
  constructor(
    public report = new RiskManagerReportService(),
  ) { }
}

export class RiskManagerReportService
  extends RestCRUDService<any, any>
{
  getEndpoint(): string {
    const url = this.config.url.api.admin
    return `${url}/riskManager/report`;
  }

  getJsonReport(projectId: string) {
    const url = `${this.getEndpoint()}/json-report?projectId=${projectId}`;
    return this.request().url(url).get().json<any>().catch(this.handleError);
  }
}
